module.exports = __webpack_public_path__ + "img/36_15.1712bf88.png";